<template>
  <div class="container rewidg-container">
    <transition name="fade">
      <div v-if="newcalcvis">
        <NewCalc />
      </div>
    </transition>

    <transition name="fade">
      <div v-if="rewidgvis" class="rewidg-wrapper">
        <div class="rewidg-card">
          <!-- Header -->
          <div class="rewidg-header">
            <div class="rewidg-icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#4a7cff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 8 9" />
              </svg>
            </div>
            <h4 class="rewidg-title">Repair Estimate</h4>
            <p class="rewidg-subtitle">Enter the repair amount to see your payment options</p>
          </div>

          <!-- Vehicle summary pill -->
          <div v-if="$store.state.userData.carDetails" class="rewidg-vehicle-pill">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="1" y="3" width="15" height="13" rx="2" />
              <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
              <circle cx="5.5" cy="18.5" r="2.5" />
              <circle cx="18.5" cy="18.5" r="2.5" />
            </svg>
            <span>{{ $store.state.userData.carDetails }}</span>
          </div>

          <!-- Amount input -->
          <div class="rewidg-field">
            <label class="rewidg-label">Estimate Amount</label>
            <div class="rewidg-input-wrap">
              <span class="rewidg-input-prefix">$</span>
              <input
                ref="estimate"
                v-model="repairOfferAmount"
                type="number"
                class="rewidg-input"
                :class="{ 'rewidg-input--valid': repairOfferAmount && Number(repairOfferAmount) > 0 }"
                placeholder="0.00"
              />
            </div>
          </div>

          <!-- Submit -->
          <button
            :disabled="!repairOfferAmount"
            class="rewidg-btn"
            @click="submit(); onpicOne()"
          >
            Continue
          </button>

          <!-- Trust line -->
          <div class="rewidg-trust">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            <span>Your information is secure and encrypted</span>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div v-if="visible" class="vue-back-to-top" :style="`bottom:${this.bottom};left:${this.left};`">
        <Main />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Rewidg',
  data() {
    return {
      step:2,
      repairOfferAmount: '',
      newcalcvis: false,
      rewidgvis: true,
      visible: false
    }
  },
  computed: {

    carSpec() {
      return this.$store.state.userData.carDetails.substring(0, 4)
    },
  },
  mounted() {
    if (!this.$store.state.userData.carDetails) {
      this.$router.push({
        name: 'Home',
      })
    }
    this.$refs.estimate.focus();
    if(this.$store.state.userData.repairOfferAmount){
      this.repairOfferAmount = this.$store.state.userData.repairOfferAmount
    }

  },

  methods: {
    closereseize(){
      if ('parentIFrame' in window)
      window.parentIFrame.size(70);
      return false;
    },
    closeWin(){
      return [this.rewidgvis = false, this.visible = true]
    },
    onpicOne() {
      if ('parentIFrame' in window)
      window.parentIFrame.size(703);
      return false;
    },
    submit() {
      this.$store.state.userData.repairOfferAmount = this.repairOfferAmount
      this.$store.state.userData.step = 3
      this.newcalcvis = true
      this.rewidgvis = false

    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

/* ── Layout ── */
.rewidg-container {
  padding-left: 0;
  padding-right: 0;
}

.rewidg-wrapper {
  display: flex;
  justify-content: center;
  padding: 0 12px;
}

/* ── Card ── */
.rewidg-card {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 22px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.07);
  padding: 32px 28px 28px;
  font-family: 'Inter', sans-serif;
}

/* ── Header ── */
.rewidg-header {
  text-align: center;
  margin-bottom: 22px;
}

.rewidg-icon-wrap {
  width: 52px;
  height: 52px;
  margin: 0 auto 10px;
  border-radius: 50%;
  background: #eef3ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rewidg-title {
  font-weight: 700;
  font-size: 20px;
  color: #1e2a3a;
  margin: 0 0 4px;
}

.rewidg-subtitle {
  font-size: 13px;
  color: #8a94a6;
  margin: 0;
}

/* ── Vehicle pill ── */
.rewidg-vehicle-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f3f6ff;
  border: 1px solid #dbe4ff;
  color: #2b3a67;
  padding: 7px 14px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 12px;
  margin: 0 auto 20px;
  text-align: center;
  width: fit-content;
  display: flex;
  justify-content: center;
}

/* ── Field ── */
.rewidg-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 20px;
}

.rewidg-label {
  font-size: 12px;
  font-weight: 600;
  color: #5a6478;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0;
}

/* ── Input ── */
.rewidg-input-wrap {
  position: relative;
}

.rewidg-input-prefix {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  font-weight: 700;
  color: #b0b7c3;
  pointer-events: none;
  transition: color 0.2s;
}

.rewidg-input {
  width: 100%;
  padding: 16px 16px 16px 36px;
  border-radius: 14px;
  border: 1px solid #e0e4ec;
  background: #f8f9fb;
  font-size: 24px;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  color: #1e2a3a;
  text-align: center;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}

.rewidg-input::placeholder {
  color: #cdd3de;
  font-weight: 500;
}

.rewidg-input:focus {
  border-color: #4a7cff;
  box-shadow: 0 0 0 3px rgba(74, 124, 255, 0.12);
  background: #fff;
}

.rewidg-input--valid {
  border-color: #34d399;
}

.rewidg-input--valid:focus {
  box-shadow: 0 0 0 3px rgba(52, 211, 153, 0.15);
}

.rewidg-input--valid ~ .rewidg-input-prefix,
.rewidg-input:focus ~ .rewidg-input-prefix {
  /* prefix doesn't change with sibling selector in this layout, keep as-is */
}

/* Hide number input arrows */
.rewidg-input[type='number']::-webkit-inner-spin-button,
.rewidg-input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.rewidg-input[type='number'] {
  -moz-appearance: textfield;
}

/* ── Button ── */
.rewidg-btn {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #4a7cff 0%, #6366f1 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: transform 0.12s, box-shadow 0.12s, opacity 0.2s;
}

.rewidg-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(74, 124, 255, 0.25);
}

.rewidg-btn:active:not(:disabled) {
  transform: scale(0.98);
}

.rewidg-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ── Trust line ── */
.rewidg-trust {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 16px;
  font-size: 11px;
  font-weight: 500;
  color: #b0b7c3;
}

/* ── Misc ── */
.vue-back-to-top {
  z-index: 1000;
  cursor: pointer;
  position: fixed;
  left: 0;
}

/* ── Transitions ── */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ── Responsive ── */
@media (max-width: 480px) {
  .rewidg-card {
    padding: 24px 18px 22px;
    border-radius: 18px;
  }

  .rewidg-input {
    font-size: 20px;
    padding: 14px 14px 14px 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rewidg.vue